import type React from "react";

export function parseMoneyInput(value: string) {
  const cleanedValue = value.replace(/[^\d.,-]/g, "").replace(/,/g, "").trim();
  const parsed = Number(cleanedValue);

  return Number.isFinite(parsed) ? parsed : null;
}

function formatMoneyLimit(maximumAmount: number) {
  return maximumAmount.toFixed(2).replace(/\.?0+$/, "");
}

export function normalizeMoneyInputText(value: string, maximumAmount: number) {
  const cleanedValue = value.replace(/[^\d.]/g, "");

  if (!cleanedValue) {
    return "";
  }

  const [wholePart, ...decimalParts] = cleanedValue.split(".");
  const normalizedWholePart = wholePart || "0";

  if (decimalParts.length === 0) {
    return Number(normalizedWholePart) > maximumAmount ? formatMoneyLimit(maximumAmount) : normalizedWholePart;
  }

  const normalizedValue = `${normalizedWholePart}.${decimalParts.join("").slice(0, 2)}`;

  return Number(normalizedValue) > maximumAmount ? formatMoneyLimit(maximumAmount) : normalizedValue;
}

export function applyMoneyInputText(
  event: CustomEvent<{ value?: string | null }>,
  setValue: React.Dispatch<React.SetStateAction<string>>,
  maximumAmount: number
) {
  const normalizedValue = normalizeMoneyInputText(event.detail.value ?? "", maximumAmount);
  const input = event.target as HTMLIonInputElement;

  input.value = normalizedValue;
  setValue(normalizedValue);
}

export function getCurrencySymbol(formatter: Intl.NumberFormat) {
  return formatter.formatToParts(0).find((part) => part.type === "currency")?.value ?? "";
}
